

import { SVGProps } from 'react';
import { twMerge } from 'tailwind-merge';

export default function BreadCrumbsArrow(props: Partial<SVGProps<any>>) {
  return (
<svg width="5" height="9" viewBox="0 0 5 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M4.5 8.5L0.5 4.5L4.5 0.5"  strokeLinecap="round" strokeLinejoin="round" className='stroke-[#212021] dark:stroke-white'/>
</svg>
  )
}
